import React from 'react'

import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'
import PelaksanaanCard from 'app/KinerjaPenilikPegawaiPage/components/PelaksanaanCard'
import { PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import useToggleSdkContext from 'utils/useToogleSdk'

import type { PenilikSummary } from 'types/kinerja-penilik-pegawai'

type SectionPelaksanaanProps = {
  isPelaksanaanState: boolean
  summary: PenilikSummary
}
const SectionPelaksanaan: React.FC<SectionPelaksanaanProps> = ({
  isPelaksanaanState,
  summary,
}) => {
  const toggles = useToggleSdkContext()
  const isPelaksanaanEnabled =
    toggles['kinerja-penilik-pegawai-pelaksanaan-enabled'] === true

  // Hide card if toggle is off
  if (!isPelaksanaanEnabled) return null

  return (
    <>
      {isPelaksanaanState && (
        <>
          <SimpleCard className="flex flex-col h-fit">
            <div className="p-6 pb-0">
              <Text variant="heading-md">Pelaksanaan</Text>
            </div>
            <PelaksanaanCard
              data-testid="praktik-kinerja-card"
              imageSrc="/illustrations/img-interactive-activity.png"
              title="Praktik Kinerja"
              state={summary?.pelaksanaanStatuses?.praktikKinerja}
              isAppealInProgress={Boolean(
                summary?.pelaksanaanStatuses?.praktikKinerjaPerubahanStatus
              )}
              href={`${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja`}
            />
            <PelaksanaanCard
              imageSrc="/illustrations/img-reflection-documents-magnifying-glass.png"
              title="Perilaku Kerja"
              state={summary?.pelaksanaanStatuses?.perilakuKerja}
              href={`${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/pelaksanaan/perilaku-kerja`}
            />
            <PelaksanaanCard
              imageSrc="/illustrations/img-flow-process.png"
              title="Pengembangan Kompetensi"
              state={summary?.pelaksanaanStatuses?.pengembanganKompetensi}
              href={`${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/pelaksanaan/pengembangan-kompetensi`}
            />
            <PelaksanaanCard
              imageSrc="/illustrations/img-book-rapor-graphic-doc.png"
              title="Pelaksanaan Tugas"
              state={summary?.pelaksanaanStatuses?.pelaksanaanTugas}
              href={`${PENGELOLAAN_KINERJA_PENILIK_PEGAWAI_PATH}/pelaksanaan/pelaksanaan-tugas`}
            />
          </SimpleCard>
        </>
      )}
    </>
  )
}

export default SectionPelaksanaan
